import type { NavItem } from "../types/header"

export const HEADER_CONSTANTS = {
  ROUTES: {
    HOME: "/",
    LOGIN: "/login",
    DASHBOARD: "/dashboard",
    PROFILE: "/dashboard/profile",
    SETTINGS: "/dashboard/settings",
  },
  LOGO: {
    ICON: "⚡",
    TEXT: "NetzSync",
  },
} as const

export const createNavItems = (onDemoClick: () => void): NavItem[] => [
  {
    label: "How It Works",
    href: "#how-it-works",
  },
  {
    label: "About Us",
    href: "#about",
  },
  {
    label: "Book a Demo",
    isButton: true,
    variant: "primary",
    onClick: onDemoClick,
  },
  {
    label: "Login",
    href: "/login",
    hideWhenAuth: true,
  },
]
